<app-grid #grid [class.ef-data-grid-locked]="showDetail" [rowSelection]="'multiple'" [domLayout]="'autoHeight'" [columnDefs]="columnDefs" [rowData]="rowData"
  [useAddAction]="!showDetail" [addLabel]="'Add'" [pagination]="false" [rowMultiSelectWithClick]="true"
  [suppressRowClickSelection]="true" [isProjectOwnershipValid]="true" (addEvent)="onAdd($event)"
  (deleteEvent)="onDelete($event)" (buttonExpandParams)="onButtonExpandClick($event)"
  (onSelectedRowEvent)="onRunSelectionChanged($event)" (onRowSelectedEmit)="onRunSelectionAllChanged($event)"
  (dropDownSelectionChangeEvent)="onDataSetFieldChanged()" (onBlurInputText)="onDataSetFieldChanged()"
  (onClickButtonEvent)="onStudyOptionsClick($event)"></app-grid>

<app-ef-data-study-options *ngIf="showStudyOptions && studyOptionsRow" [dataSetRow]="studyOptionsRow"
  [efateSetupPk]="currentEfateSetupPk" (saved)="onStudyOptionsSaved($event)"
  (closed)="onStudyOptionsClosed()"></app-ef-data-study-options>

<app-ef-data-model-parameters *ngIf="parametersModelType && parametersTopology && expandedRow"
  [modelType]="parametersModelType" [topology]="parametersTopology" [nodeNames]="topologyNodeNames"
  [savedSet]="expandedRow.modelParameters?.[parametersModelType]" (saved)="onModelParametersSaved($event)"
  (closed)="onModelParametersClosed()"></app-ef-data-model-parameters>

<app-loading *ngIf="showDetail && isDetailLoading" class="mt-3 flex align-items-center justify-content-center"></app-loading>

<div class="ef-data-detail" *ngIf="showDetail && expandedRow && !isDetailLoading">
  <div class="ef-data-top-row">
    <div class="ef-data-group-selector">
      <label class="ef-data-group-label" for="efDataGroupSelect">Select Data Group:</label>
      <select id="efDataGroupSelect" class="ef-data-group-input" [style.background-color]="selectedGroupColor"
        [ngModel]="expandedRow.dataGroupKey" (ngModelChange)="onDataGroupChange($event)">
        <option *ngFor="let group of dataGroupOptions" [value]="group.groupKey"
          [style.background-color]="getGroupColor(group.groupKey)">{{ group.groupName }}</option>
      </select>
    </div>

    <div class="ef-data-options">
      <div class="ef-data-option-group">
        <span class="ef-data-option-label">{{ extraSolverLabel }}</span>
        <div class="ef-data-option-card">
          <div class="ef-data-option-item" *ngFor="let option of extraSolverOptions">
            <p-radioButton name="efExtraSolver" [inputId]="'efExtraSolver-' + option.value" [value]="option.value"
              [ngModel]="extraSolverOption" (ngModelChange)="onExtraSolverChange($event)"></p-radioButton>
            <label class="ef-data-option-text" [for]="'efExtraSolver-' + option.value">{{ option.label }}</label>
          </div>
        </div>
      </div>

      <div class="ef-data-option-group">
        <span class="ef-data-option-label">{{ modelsToRunLabel }}</span>
        <div class="ef-data-option-card">
          <div class="ef-data-option-item" *ngFor="let model of modelOptions()">
            <p-checkbox name="efModelsToRun" [inputId]="'efModel-' + model" [value]="model"
              [ngModel]="selectedModels" (ngModelChange)="onModelsChange($event)"></p-checkbox>
            <button *ngIf="selectedModels.includes(model); else modelNameLabel" type="button"
              class="ef-data-model-link" pTooltip="Set parameters" tooltipPosition="top"
              (click)="onModelParametersClick(model)">{{ model }}</button>
            <ng-template #modelNameLabel>
              <label class="ef-data-option-text" [for]="'efModel-' + model">{{ model }}</label>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="ef-data-detail-body">
    <div class="ef-data-topology-card" [style.--group-color]="selectedGroupColor">
      <app-ef-cake-topology-structure [readonlyMode]="true" sizeVariant="small" [groupColor]="selectedGroupColor"
        [nodeNames]="topologyNodeNames" [activeEdges]="selectedGroupActiveEdges"
        [activeStatusNodes]="selectedGroupActiveStatusNodes"
        [bidirectionalEdgeDirections]="selectedGroupBidirectionalEdges">
      </app-ef-cake-topology-structure>
    </div>

    <div class="ef-data-experiment-card">
      <ag-grid-angular class="ag-theme-alpine ef-data-experiment-grid" [style.height]="experimentGridHeight"
        [columnDefs]="experimentColumnDefs" [rowData]="experimentRowData" [defaultColDef]="experimentDefaultColDef"
        [rowHeight]="experimentRowHeight" [headerHeight]="experimentHeaderHeight" [enableRangeSelection]="true"
        [suppressCopyRowsToClipboard]="false" [stopEditingWhenCellsLoseFocus]="true"
        [processDataFromClipboard]="processDataFromClipboard" (gridReady)="onExperimentGridReady($event)"
        (cellValueChanged)="onExperimentCellValueChanged()">
      </ag-grid-angular>
    </div>
  </div>
</div>
